export default __webpack_public_path__ + "static/media/profile.8830bcea.jpeg";